import { type ComponentProps } from 'react';

import { useMediaQuery } from '@chakra-ui/react';

import CustomModal from '../components/CustomModal/CustomModal';
import { MOBILE_VIEWPORT_QUERY } from '../enums/screenBreakpoints';

type ModalSize = ComponentProps<typeof CustomModal>['size'];

export function useResponsiveModalProps(desktopSize: ModalSize = 'md') {
  const [isMobile] = useMediaQuery(MOBILE_VIEWPORT_QUERY);

  return {
    size: (isMobile ? 'full' : desktopSize) as ModalSize,
    isCentered: !isMobile,
  };
}
